// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $            from 'jquery';

require('./third/jquery.webslider');

export default class StyleGuideWebslider extends WebComponent {
  didMount() {
    const {
            localeButton,
            source,
          } = this.props;

    //console.log('slider init');

    $(this.element).webslider({
      localeButton: localeButton,
      dataSource:   JSON.parse(source),
    });
  }
}




// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/SeriesDetailWebslider.js